import React from 'react';
import {
	ActionsNode,
	ResponseRendererProps,
	TradingAction,
} from 'pages/Chat/MarkdownRender';
import { Button, Stack } from '@mui/material';
import { styled } from '@mui/system';

const StyledButton = styled(Button)(() => ({
	borderRadius: '12px',
	border: '1px solid #E0E0E0',
	backgroundColor: '#fff',
	color: '#000',
	textTransform: 'none',
	fontSize: '16px',
	fontWeight: 400,
	padding: '10px 24px',
	boxShadow: 'none',
	'&:hover': {
		backgroundColor: '#f5f5f5',
		boxShadow: 'none',
	},

	'&.Mui-disabled': {
		backgroundColor: '#f0f0f0',
		color: '#9e9e9e',
		border: '1px solid #e0e0e0',
		boxShadow: 'none',
	},
}));

const ConfirmButton = styled(Button)(() => ({
	borderRadius: '12px',
	border: '1px solid #E0E0E0',
	backgroundColor: '#171717',
	color: '#fff',
	textTransform: 'none',
	fontSize: '16px',
	fontWeight: 400,
	padding: '10px 24px',
	boxShadow: 'none',
	'&:hover': {
		backgroundColor: '#565656',
		boxShadow: 'none',
	},

	'&.Mui-disabled': {
		backgroundColor: '#f0f0f0',
		color: '#9e9e9e',
		border: '1px solid #e0e0e0',
		boxShadow: 'none',
	},
}));

const TradingActions: React.FC<{
	actions?: TradingAction[];
	onAction?: ResponseRendererProps['onAction'];
	raw?: string;
	isCurrent?: boolean;
}> = ({ actions, onAction, raw, isCurrent }) => {
	if (!actions?.length) return null;

	return (
		<>
			<Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
				{actions.map((a, idx) =>
					a.id === 'confirm' ? (
						<ConfirmButton
							key={`${a?.id}-${idx}`}
							size="small"
							variant="contained"
							disabled={!isCurrent}
							onClick={() =>
								onAction?.(
									a.id || '',
									a.data,
									a.label ?? '',
									raw,
								)
							}
						>
							{a.label || a.id || `Action ${idx + 1}`}
						</ConfirmButton>
					) : (
						<StyledButton
							key={`${a?.id}-${idx}`}
							size="small"
							variant="contained"
							onClick={() =>
								onAction?.(
									a.id || '',
									a.data,
									a.label ?? '',
									raw,
								)
							}
							disabled={!isCurrent}
						>
							{a.label || a.id || `Action ${idx + 1}`}
						</StyledButton>
					),
				)}
			</Stack>
		</>
	);
};

export const ActionsView: React.FC<{
	node: ActionsNode;
	onAction?: ResponseRendererProps['onAction'];
	raw: string;
	isCurrent?: boolean;
}> = ({ node, onAction, raw, isCurrent }) => (
	<TradingActions
		actions={node.actions}
		onAction={onAction}
		raw={raw}
		isCurrent={isCurrent}
	/>
);
